import { SectionCard, SectionCardTitle } from "@/components";
import HistoryImageGrid from "./ImageGrid";
import { GrowthInnovation } from "./GrowthInnovation";
import { Meta } from "@/components";

const OurHistory = () => {
  return (
    <>
    <Meta
        title="Intron - Our History"
    />
    <SectionCard className="px-4 lg:px-[90px] mx-0 h-auto">
      <div className="flex flex-col lg:flex-row items-start justify-between gap-10">
        <div className="lg:w-1/2 w-full lg:mt-25">
          <SectionCardTitle>Our History</SectionCardTitle>
          <p className="text-[14px] lg:text-[16px] leading-[24px] lg:leading-[28px]  text-justify text-[#415667] mt-4">
             Celebrating <span className="font-bold">27+ years</span> of innovation in sustainable animal health. From local roots to global breakthroughs, our journey continues to shape the future of biotechnology.
          </p>
        </div>
        <div className="lg:w-2/3 w-full flex justify-start lg:justify-end">
        <div className="w-fit">
          <HistoryImageGrid />
        </div>
        </div>

      </div>
    </SectionCard>
    <GrowthInnovation />
  </>
  );
};

export default OurHistory;
